import React, { useEffect, useState } from "react";
import styles from "@/components/common/BuyNow/BuyNow.module.scss";
import useBuyNow from "@/helpers/hooks/useBuyNow";
import Srcset from "../Srcset";

const BuyNowButton = ({ selectedVariant, isSizeSelected, isSizeDropdownOpen, setIsSizeDropdownOpen,badgeCurated, product,engravingAdded }) => {
  const { handleBuyNow, loading } = useBuyNow(selectedVariant, isSizeSelected, isSizeDropdownOpen, setIsSizeDropdownOpen, badgeCurated, product, engravingAdded);
  const [isAppleDevice, setIsAppleDevice] = useState(false);
  // Check if the device is an Apple device in the browser environment
  useEffect(() => {
    if (typeof navigator !== "undefined") {
      setIsAppleDevice(/iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent));
    }
  }, []);

  return (
    <button
      type="button"
      className={`btn-primary medium ga-buy-now ${loading ? "loading" : ""} ${styles.buy_now}`}
      onClick={handleBuyNow}
      disabled={loading}
      tabIndex={0}
    >
      {loading ? "" : <>
        {
          isAppleDevice ? (
            <>
              <span className={"ga-buy-now"}
              >Buy with</span>
              <Srcset
                className={"ga-buy-now"}
                src={`${process.env.NETLIFY_URL}/images/Payment-logos/Apple_Pay-White-Logo.png`}
                alt="apple-button-buy-now"
                svgFile={true}
                height="35"
              />
            </>
          ) :
            <span className={"ga-buy-now"}
            >Buy now</span>

        }
      </>}
    </button>
  );
};

export default BuyNowButton;
